import React from 'react';
import {
  BlockToolbarButton,
  ELEMENT_DEFAULT,
  ELEMENT_OL,
  ELEMENT_UL,
  getPluginType,
  LinkToolbarButton,
  MARK_BOLD,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_UNDERLINE,
  MarkToolbarButton,
} from '@udecode/plate';
import { faBold } from '@fortawesome/pro-regular-svg-icons/faBold';
import { faItalic } from '@fortawesome/pro-regular-svg-icons/faItalic';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faListOl } from '@fortawesome/pro-regular-svg-icons/faListOl';
import { faListUl } from '@fortawesome/pro-regular-svg-icons/faListUl';
import { faStrikethrough } from '@fortawesome/pro-regular-svg-icons/faStrikethrough';
import { faUnderline } from '@fortawesome/pro-regular-svg-icons/faUnderline';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

import { AddMemoryToolbarButton } from './components/AddMemoryToolbarButton';
import { Emoji, Tooltip } from 'src/presentation/components/agent_desktop_components';
import { MEMORY_PLUGIN_NAME } from './plugins/memorySelectorPlugin/createMemorySelectorPlugin';

const EditorToolbar = ({ attr, editorRef, disabled }) => {
  if (disabled) {
    return null;
  }

  return (
    <StyledToolbar>
      <Emoji editorRef={editorRef} menuMargin={0} menuPosition="top" positionRef={null} />

      <Tooltip message="Bold">
        <MarkToolbarButton
          editorRef={editorRef.current}
          type={getPluginType(editorRef.current, MARK_BOLD)}
          icon={<FontAwesomeIcon icon={faBold} />}
          title="Bold"
        />
      </Tooltip>
      <Tooltip message="Italic">
        <MarkToolbarButton
          editorRef={editorRef.current}
          type={getPluginType(editorRef.current, MARK_ITALIC)}
          icon={<FontAwesomeIcon icon={faItalic} />}
          title="Bold"
        />
      </Tooltip>
      <Tooltip message="Underline">
        <MarkToolbarButton
          editorRef={editorRef.current}
          type={getPluginType(editorRef.current, MARK_UNDERLINE)}
          icon={<FontAwesomeIcon icon={faUnderline} />}
          title="Bold"
        />
      </Tooltip>
      <Tooltip message="Strike Through">
        <MarkToolbarButton
          editorRef={editorRef.current}
          type={getPluginType(editorRef.current, MARK_STRIKETHROUGH)}
          icon={<FontAwesomeIcon icon={faStrikethrough} />}
          title="Bold"
        />
      </Tooltip>

      <Tooltip message="Ordered List">
        <BlockToolbarButton
          type={getPluginType(editorRef.current, ELEMENT_OL)}
          icon={<FontAwesomeIcon icon={faListOl} />}
          inactiveType={ELEMENT_DEFAULT}
        />
      </Tooltip>
      <Tooltip message="Unordered List">
        <BlockToolbarButton
          type={getPluginType(editorRef.current, ELEMENT_UL)}
          icon={<FontAwesomeIcon icon={faListUl} />}
          inactiveType={ELEMENT_DEFAULT}
        />
      </Tooltip>

      <Tooltip message="Memory Selector">
        <AddMemoryToolbarButton type={getPluginType(editorRef.current, MEMORY_PLUGIN_NAME)} icon={<>/M</>} />
      </Tooltip>

      <Tooltip message="Link">
        <LinkToolbarButton tooltip={undefined} id={attr} icon={<FontAwesomeIcon icon={faLink} />} />
      </Tooltip>
    </StyledToolbar>
  );
};

const StyledToolbar = styled.div`
  align-items: center;
  border-bottom: 1px solid ${p => p.theme.colors.gray400};
  display: flex;
  height: 35px;
  padding: 0 8px;
`;

export default EditorToolbar;
